import { render } from "./ProposalSettingsModal.vue?vue&type=template&id=beb100e4&scoped=true&ts=true"
import script from "./ProposalSettingsModal.vue?vue&type=script&lang=ts"
export * from "./ProposalSettingsModal.vue?vue&type=script&lang=ts"

import "./ProposalSettingsModal.vue?vue&type=style&index=0&id=beb100e4&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb100e4"]])

export default __exports__